import * as React from 'react';

// Components
import { ResponsiveImage } from '@shopee-user/shared-customization-ui';

// Utils
import { Layout, useResponsiveLayout } from '@shopee-user/layout-responsive';

// Assets
import imageDesktopMdpi from './assets/desktop/one-credential-delink-success-image-1x.png';
import imageDesktopHdpi from './assets/desktop/one-credential-delink-success-image-1.5x.png';
import imageDesktopXhdpi from './assets/desktop/one-credential-delink-success-image-2x.png';
import imageDesktopXxhdpi from './assets/desktop/one-credential-delink-success-image-3x.png';
import imageDesktopXxxhdpi from './assets/desktop/one-credential-delink-success-image-4x.png';

import imageMobileMdpi from './assets/mobile/one-credential-delink-success-image-1x.png';
import imageMobileHdpi from './assets/mobile/one-credential-delink-success-image-1.5x.png';
import imageMobileXhdpi from './assets/mobile/one-credential-delink-success-image-2x.png';
import imageMobileXxhdpi from './assets/mobile/one-credential-delink-success-image-3x.png';
import imageMobileXxxhdpi from './assets/mobile/one-credential-delink-success-image-4x.png';

type Props = { className?: string };

function OneCredentialDelinkSuccessImage({ className }: Props) {
  const { layout } = useResponsiveLayout();
  const getSrcSet = () => {
    if (layout === Layout.Desktop) {
      return [
        `${imageDesktopMdpi} 1x`,
        `${imageDesktopHdpi} 1.5x`,
        `${imageDesktopXhdpi} 2x`,
        `${imageDesktopXxhdpi} 3x`,
        `${imageDesktopXxxhdpi} 4x`,
      ].join(',');
    } else {
      return [
        `${imageMobileMdpi} 1x`,
        `${imageMobileHdpi} 1.5x`,
        `${imageMobileXhdpi} 2x`,
        `${imageMobileXxhdpi} 3x`,
        `${imageMobileXxxhdpi} 4x`,
      ].join(',');
    }
  };

  return (
    <ResponsiveImage
      className={className}
      defaultSrc={
        layout === Layout.Desktop ? imageDesktopXhdpi : imageMobileXhdpi
      }
      srcSet={getSrcSet()}
    />
  );
}

export default OneCredentialDelinkSuccessImage;
